import {accRestClient} from "../index";


const loadUsers = async (search = "", statusFilters = [], jamaat = null, country = null, dateOfBirth = null, address = null, urduName = null, firstName = null, lastName = null, email = null, aimsId = null, city = null, zipCode = null, state = null, streetLine1 = null, streetLine2 = null, contactNumber = null, gender = null, page = 0, size = 10) => {
  const response = await accRestClient.accountsApi().searchUsers(search, statusFilters, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size);
  return response.data;
};

const loadUsersWithDetails = async (event) => {
  const response = await accRestClient.accountsApi().getUsersWithDetails("");
  return response.data;
};

const loadMe = async (data) => {
  const response = await accRestClient.accountsApi().getMe();
  return response.data;
};

const updateUserTajneed = async (data) => {
  const response = await accRestClient.accountsApi().addTajneedData(data.userId, data.userData);
  return response.data;
};

const deleteUserAccounts = async (data) => {
  const response = await accRestClient.accountsApi().rejectUsers(data.users);
  return response.data;
};

const activateUserAccounts = async (data) => {
  const response = await accRestClient.accountsApi().enableUsers(data.users);
  return response.data;
};

const deactivateUserAccounts = async (data) => {
  const response = await accRestClient.accountsApi().disableUsers(data.users);
  return response.data;
};

const approveUserAccounts = async (data) => {
  const response = await accRestClient.accountsApi().approveUsers(data.users);
  return response.data;
};

const resendEmailVerification = async (userId) => {
  const response = await accRestClient.accountsApi().resendEmailVerification(userId);
  return response.data;
};

const setEmailVerified = async (userId) => {
  const response = await accRestClient.accountsApi().setEmailVerified(userId);
  return response.data;
};

const resetUserTwoFactor = async (userId) => {
  const response = await accRestClient.accountsApi().resetUserTwoFactor(userId);
  return response.data;
};

const loadActiveUsers = async (event) => {
  const response = await accRestClient.accountsApi().getUsers("amj-account-verified:true");
  return response.data;
};

const loadNotActiveUsers = async (event) => {
  const response = await accRestClient.accountsApi().getUsers("amj-account-verified:false");
  return response.data;
};

const getUsersByRole = async (roleName) => {
  const response = await accRestClient.accountsApi().getUsersByRole(roleName);
  return response.data;
};

// Duplicate clusters, pre-ranked server-side by rulesMatched DESC, neighbourCount DESC, userId.
// The DTO carries no member names — only the account id and its collision counts.
const getTopDuplicateAccounts = async (maxAccounts = 50) => {
  const response = await accRestClient.accountsApi().getTopDuplicateAccounts(maxAccounts);
  return response.data;
};

// Fully hydrated UserDataDtos for the accounts colliding with userId. Excludes userId
// itself, and the query has no ORDER BY, so any ordering must be applied client-side.
const getDuplicateAccounts = async (userId) => {
  const response = await accRestClient.accountsApi().getDuplicateAccounts(userId);
  return response.data;
};

// A single hydrated UserDataDto. Needed because getDuplicateAccounts leaves the
// account being examined out of its own result set.
const getUserData = async (userId) => {
  const response = await accRestClient.accountsApi().getUserData(userId);
  return response.data;
};

const accountRestService = {
  loadUsers,
  updateUserTajneed,
  approveUserAccounts,
  deleteUserAccounts,
  activateUserAccounts,
  deactivateUserAccounts,
  resendEmailVerification,
  setEmailVerified,
  resetUserTwoFactor,
  loadMe,
  getUsersByRole,
  getTopDuplicateAccounts,
  getDuplicateAccounts,
  getUserData
};

export default accountRestService;